// extracted by css-extract-rspack-plugin
export default {"emptyContract":"_3d2f392e"};